export default "__VITE_ASSET__IaFqewte__"